import { css } from '@emotion/react';
import type { ReactElement } from 'react';

import { styled } from '../../../styled';
import type { Theme } from '../../../theme/interface/detailed';
import { useTheme } from '../../../theme/useTheme';

type Interface = { className: string; onClick: VoidFunction };

const Component = ({ className, onClick }: Interface): ReactElement => {
	const theme = useTheme();
	return (
		<div className={className} onClick={onClick}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={theme.allSettings.icons.angleDownIcon.width}
				height={theme.allSettings.icons.angleDownIcon.height}
				viewBox="0 0 24 24"
				fill="transparent"
				stroke={theme.allSettings.icons.angleDownIcon.fill}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<polyline points="6 9 12 15 18 9" strokeWidth="3" />
			</svg>
		</div>
	);
};

export const AngleDownIcon = styled(Component)(
	({
		theme: {
			allSettings: {
				icons: { angleDownIcon },
			},
		},
	}: {
		theme: Theme;
	}) =>
		css`
			align-items: center;
			cursor: pointer;
			display: flex;
			height: 100%;
			${angleDownIcon}
		`
);
